export const OverlayLayoutConfig = {
  transitionDuration: 300,
}
